export default __webpack_public_path__ + "static/media/USB-connected.f2fe8485.svg";